export const month = {
  NONE: [0, "ไม่เลือก"],
  ONE: [1, "1 เดือน"],

  TWO: [2, "2 เดือน"],

  THREE: [3, "3 เดือน"],

  FOUR: [4, "4 เดือน"],

  FIVE: [5, "5 เดือน"],

  SIX: [6, "6 เดือน"],

  SEVEN: [7, "7 เดือน"],

  EIGHTT: [8, "8 เดือน"],

  NINE: [9, "9 เดือน"],

  TEN: [10, "10 เดือน"],

  ELEVEN: [11, "11 เดือน"],

  TWELVE: [12, "12 เดือน"],

  THIRTEEN: [13, "13 เดือน"],

  FOURTEEN: [14, "14เดือน"],

  FIFTEEN: [15, "15 เดือน"],

  SIXTEEN: [16, "16 เดือน"],

  SEVENTEEN: [17, "17 เดือน"],

  EIGHTTTEEN: [18, "18 เดือน"],

  NINETEEN: [19, "19 เดือน"],

  TWENTY_: [20, "20 เดือน"],

  TWENTY_ONE: [21, "21 เดือน"],

  TWENTY_TWO: [22, "22 เดือน"],

  TWENTY_THREE: [23, "23 เดือน"],

  TWENTY_FOURE: [24, "24 เดือน"],

  TWENTY_FIVE: [25, "25 เดือน"],

  TWENTY_SIX: [26, "26 เดือน"],

  TWENTY_SEVEN: [27, "27 เดือน"],

  TWENTY_EIGHT: [28, "28 เดือน"],

  TWENTY_NINE: [29, "29 เดือน"],

  THIRTY: [30, "30 เดือน"],

  THIRTY_ONE: [31, "31 เดือน"],

  THIRTY_TWO: [32, "32 เดือน"],

  THIRTY_THREE: [33, "33 เดือน"],

  THIRTY_FOURE: [34, "34 เดือน"],

  THIRTY_FIVE: [35, "35 เดือน"],

  THIRTY_SIX: [36, "36 เดือน"],

  THIRTY_SEVEN: [37, "37 เดือน"],

  THIRTY_EIGHT: [38, "38 เดือน"],

  THIRTY_NINE: [39, "39 เดือน"],

  FOURTY: [40, "40 เดือน"],

  FOURTY_ONE: [41, "41 เดือน"],

  FOURTY_TWO: [42, "42 เดือน"],

  FOURTY_THREE: [43, "43 เดือน"],

  FOURTY_FOUR: [44, "44 เดือน"],

  FOURTY_FIVE: [45, "45 เดือน"],

  FOURTY_SIX: [46, "46 เดือน"],

  FOURTY_SEVEN: [47, "47 เดือน"],

  FOURTY_EIGHT: [48, "48 เดือน"],

  FOURTY_NICE: [49, "49 เดือน"],

  FIVTY: [50, "50 เดือน"],

  FIVTY_ONE: [51, "51 เดือน"],

  FIVTY_TWO: [52, "52 เดือน"],

  FIVTY_THREE: [53, "53 เดือน"],

  FIVTY_FOURE: [54, "54 เดือน"],

  FIVTY_FIVE: [55, "55 เดือน"],

  FIVTY_SIX: [56, "56 เดือน"],

  FIVTY_SEVEN: [57, "57 เดือน"],

  FIVTY_EIGHT: [58, "58 เดือน"],

  FIVTY_NINE: [59, "59 เดือน"],

  SIXTY: [60, "60 เดือน"],

  SIXTY_ONE: [61, "61 เดือน"],

  SIXTY_TWO: [62, "62 เดือน"],

  SIXTY_THREE: [63, "63 เดือน"],

  SIXTY_FOURE: [64, "64 เดือน"],

  SIXTY_FIVE: [66, "66 เดือน"],

  SIXTY_SIX: [66, "66 เดือน"],

  SIXTY_SEVEN: [67, "67 เดือน"],

  SIXTY_EIGHT: [68, "68 เดือน"],

  SIXTY_NINE: [69, "69 เดือน"],

  SEVENTY: [70, "70 เดือน"],

  SEVENTY_ONE: [71, "71 เดือน"],

  SEVENTY_TWO: [72, "72 เดือน"],

  SEVENTY_THREE: [73, "73 เดือน"],

  SEVENTY_FOURE: [74, "74 เดือน"],

  SEVENTY_FIVE: [75, "75 เดือน"],

  SEVENTY_SIX: [76, "76 เดือน"],

  SEVENTY_SEVEN: [77, "77 เดือน"],

  SEVENTY_EIGHT: [78, "78 เดือน"],

  SEVENTY_NINE: [79, "79 เดือน"],

  EIGHTY: [80, "80 เดือน"],

  EIGHTY_ONE: [81, "81 เดือน"],

  EIGHTY_TWO: [82, "82 เดือน"],

  EIGHTY_THREE: [83, "83 เดือน"],

  EIGHTY_FOURE: [84, "84 เดือน"],

  EIGHTY_FIVE: [85, "85 เดือน"],

  EIGHTY_SIX: [86, "86 เดือน"],

  EIGHTY_SEVEN: [87, "87 เดือน"],

  EIGHTY_EIGHT: [88, "88 เดือน"],

  EIGHTY_NINE: [89, "89 เดือน"],

  NINETY: [90, "90 เดือน"],

  NINETY_ONE: [91, "91 เดือน"],

  NINETY_TWO: [92, "92 เดือน"],

  NINETY_THREE: [93, "93 เดือน"],

  NINETY_FOURE: [94, "94 เดือน"],

  NINETY_FIVE: [95, "95 เดือน"],

  NINETY_SIX: [96, "96 เดือน"],

  NINETY_SEVEN: [97, "97 เดือน"],

  NINETY_EIGHT: [98, "98 เดือน"],

  NINETY_NINE: [99, "99 เดือน"],

  ONE_HUNDRED: [100, "100 เดือน"],

  ONE_HUNDRED_ONE: [101, "101 เดือน"],

  ONE_HUNDRED_TWO: [102, "102 เดือน"],

  ONE_HUNDRED_THREE: [103, "103 เดือน"],

  ONE_HUNDRED_FOURE: [104, "104 เดือน"],

  ONE_HUNDRED_FIVE: [105, "105 เดือน"],

  ONE_HUNDRED_SIX: [106, "106 เดือน"],

  ONE_HUNDRED_SEVEN: [107, "107 เดือน"],

  ONE_HUNDRED_EIGHT: [108, "108 เดือน"],

  ONE_HUNDRED_NINE: [109, "109 เดือน"],

  ONE_HUNDRED_TEN: [110, "110 เดือน"],

  ONE_HUNDRED_ELEVEN: [111, "111 เดือน"],

  ONE_HUNDRED_TWELVE: [112, "112 เดือน"],

  ONE_HUNDRED_THIRTEEN: [113, "113 เดือน"],

  ONE_HUNDRED_FOURETEEN: [114, "114 เดือน"],

  ONE_HUNDRED_FIVETEEN: [115, "115 เดือน"],

  ONE_HUNDRED_SIXTEEN: [116, "116 เดือน"],

  ONE_HUNDRED_SEVENTEEN: [117, "117 เดือน"],

  ONE_HUNDRED_EIGHTEEN: [118, "118 เดือน"],

  ONE_HUNDRED_NINETEEN: [119, "119 เดือน"],

  ONE_HUNDRED_TWENTY: [120, "120 เดือน"],
};

export const getSelectOptions = (list) =>
  Object.entries(list).map(([key, [value, label]]) => ({
    value,
    label,
  }));

export const optionsMonth = [...getSelectOptions(month)];
